import { render, staticRenderFns } from "./AnswerCourse.vue?vue&type=template&id=718b0154&scoped=true&"
import script from "./AnswerCourse.vue?vue&type=script&lang=js&"
export * from "./AnswerCourse.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCourse.vue?vue&type=style&index=0&id=718b0154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b0154",
  null
  
)

export default component.exports